import React, { useState } from "react";
import { Box, Container, Text, VStack } from "@chakra-ui/react";
import { pageFadeIn } from "../../../utils/animations";
import NavBar from "../../../Components/Navbar/NavBar";
import Sales from "./SalesPB";
import Reports from "./ReportsPB";
import About from "./AboutPB";
import pb_logo from "../../../Assets/pb_logo.png";
import axios from "axios";

function PB() {
  const [selectedOption, setSelectedOption] = useState("Sales");
  
  const handleTabClick = async (tab) => {
    setSelectedOption(tab);
    const resJWTTableau = await axios.get(
      `${process.env.REACT_APP_BACKEND_API_URL}/generatejwt`,
      { withCredentials: true }
    );
    localStorage.setItem("tableauToken", resJWTTableau.data);
  };

  const renderContent = () => {
    switch (selectedOption) {
      case "Sales":
        return <Sales content="Sales PB" color="blue" />;
      case "Reports":
        return <Reports content="Reports PB" />;
      case "About":
        return <About content="About PB" />;
      default:
        return <Sales content="Sales PB" color="blue" />;
    }
  };

  return (
    <Box h="100vh" bg="gray.50" overflow="hidden">
      <NavBar 
        tabIndicatorColor="blue.500" 
        logo={pb_logo} 
        onTabClick={handleTabClick} 
      />
      
      <Box
      w="100%"
      h="calc(100vh - 60px)"
      overflow="hidden"
      bgColor="white"
      bgImage={`linear-gradient(rgba(255,255,255,0.88), rgba(255,255,255,0.88)), url(${pb_logo})`}
      bgRepeat="no-repeat"
      bgSize="40% auto"
      bgPosition="right -80px"
      sx={{ animation: `${pageFadeIn} 0.55s ease both` }}
    >
        {renderContent()}
      </Box>
    </Box>
  );
}

export default PB;
